import React, { useState, useEffect } from 'react';

const Typewriter = ({
  text,
  delay,
  onStartTyping,
  onFinishTyping,
  isQuery = false,
  classQuery,
}) => {
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [doneTypying, setDoneTypying] = useState(false);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setCurrentText((prevText) => prevText + text[currentIndex]);
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }, delay);

      return () => clearTimeout(timeout);
    }
  }, [currentIndex, delay, text]);

  useEffect(() => {
    if (currentIndex === 0 && onStartTyping) {
      onStartTyping();
    }

    if (currentIndex >= text.length && !doneTypying && onFinishTyping) {
      setDoneTypying(true);
      onFinishTyping();
    }
  }, [currentIndex, doneTypying, onFinishTyping, onStartTyping, text]);

  return (
    <div
      id='content'
      className={classQuery ? classQuery : ''}
      style={{ fontSize: isQuery ? '1.1rem' : '1.25rem' }}
      dangerouslySetInnerHTML={{ __html: currentText }}
    ></div>
  );
};

export default Typewriter;
